var _rect, _rect2, _rect3, _line, _rect4, _path, _path2, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _ellipse, _rect5, _line70, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _rect6, _rect7, _circle2, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDeniedArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 162,
    viewBox: "0 0 304 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.418546,
    y: 26.4185,
    width: 278.163,
    height: 134.588,
    rx: 5.2538,
    fill: "white",
    stroke: "#34CB65",
    strokeWidth: 0.837092
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1279,
    y: 46.5527,
    width: 125.359,
    height: 8.56609,
    rx: 2.26894,
    fill: "#C4E8D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1279,
    y: 63.6836,
    width: 100.968,
    height: 8.56609,
    rx: 2.26894,
    fill: "#C4E8D0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.8252,
    y1: 95.2798,
    x2: 251.414,
    y2: 95.2798,
    stroke: "#DEDEDE",
    strokeWidth: 0.627819
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3672,
    y: 100.533,
    width: 244.501,
    height: 53.7146,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.415 128.256C47.415 134.313 42.536 139.218 36.5224 139.218C30.5088 139.218 25.6298 134.313 25.6298 128.256C25.6298 122.2 30.5088 117.295 36.5224 117.295C42.536 117.295 47.415 122.2 47.415 128.256Z",
    fill: "#34CB65",
    fillOpacity: 0.2,
    stroke: "#34CB65",
    strokeWidth: 0.773298
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5899 128.181C40.761 128.281 40.761 128.528 40.5899 128.627L34.4598 132.188C34.2879 132.288 34.0725 132.164 34.0725 131.965L34.0725 124.843C34.0725 124.645 34.2879 124.521 34.4598 124.62L40.5899 128.181Z",
    fill: "#34CB65"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 95.6806,
    y1: 133.631,
    x2: 95.6806,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60.9501,
    y1: 134.527,
    x2: 60.9501,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 55.3095,
    y1: 142.59,
    x2: 55.3095,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 93.0058,
    y1: 142.59,
    x2: 93.0058,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 58.2783,
    y1: 138.408,
    x2: 58.2783,
    y2: 144.978,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 98.6493,
    y1: 133.631,
    x2: 98.6493,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 63.9189,
    y1: 139.902,
    x2: 63.9189,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 101.615,
    y1: 133.334,
    x2: 101.615,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 66.8847,
    y1: 137.514,
    x2: 66.8847,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 104.583,
    y1: 135.125,
    x2: 104.583,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 69.8525,
    y1: 135.125,
    x2: 69.8525,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 107.253,
    y1: 137.514,
    x2: 107.253,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 72.5273,
    y1: 135.125,
    x2: 72.5273,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 110.224,
    y1: 135.424,
    x2: 110.224,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 75.495,
    y1: 135.424,
    x2: 75.495,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 113.191,
    y1: 133.631,
    x2: 113.191,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 78.4638,
    y1: 133.631,
    x2: 78.4638,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 116.16,
    y1: 135.424,
    x2: 116.16,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 81.4296,
    y1: 134.527,
    x2: 81.4296,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 118.832,
    y1: 139.605,
    x2: 118.832,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 84.1015,
    y1: 139.605,
    x2: 84.1015,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 121.798,
    y1: 136.32,
    x2: 121.798,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 87.0693,
    y1: 136.32,
    x2: 87.0693,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 124.766,
    y1: 132.139,
    x2: 124.766,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 90.038,
    y1: 137.514,
    x2: 90.038,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 127.734,
    y1: 141.098,
    x2: 127.734,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 130.409,
    y1: 130.346,
    x2: 130.409,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 244.898,
    y1: 135.473,
    x2: 244.898,
    y2: 144.88,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 248.259,
    y1: 138.832,
    x2: 248.259,
    y2: 144.879,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 251.616,
    y1: 138.16,
    x2: 251.616,
    y2: 144.879,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 133.375,
    y1: 124.971,
    x2: 133.375,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 14.6333,
    y2: -0.386649,
    transform: "matrix(-4.34455e-08 1 1 4.3979e-08 241.328 130.346)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 136.346,
    y1: 130.346,
    x2: 136.346,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 15.8279,
    y2: -0.386649,
    transform: "matrix(-4.34454e-08 1 1 4.39789e-08 238.359 129.152)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 139.309,
    y1: 129.152,
    x2: 139.309,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 16.7238,
    y2: -0.386649,
    transform: "matrix(-4.34455e-08 1 1 4.3979e-08 235.69 128.256)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 141.983,
    y1: 128.256,
    x2: 141.983,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 20.0088,
    y2: -0.386649,
    transform: "matrix(-4.34454e-08 1 1 4.39789e-08 232.722 124.971)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 144.951,
    y1: 124.971,
    x2: 144.951,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 13.7374,
    y2: -0.386649,
    transform: "matrix(-4.34454e-08 1 1 4.39789e-08 229.751 131.242)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 147.92,
    y1: 131.242,
    x2: 147.92,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 20.3075,
    y2: -0.386649,
    transform: "matrix(-4.34455e-08 1 1 4.3979e-08 226.785 124.674)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 150.888,
    y1: 129.152,
    x2: 150.888,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    y1: -0.386649,
    x2: 4.18095,
    y2: -0.386649,
    transform: "matrix(-4.34454e-08 1 1 4.39789e-08 224.113 140.799)",
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 153.56,
    y1: 140.799,
    x2: 153.559,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 156.525,
    y1: 139.305,
    x2: 156.525,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 159.494,
    y1: 133.033,
    x2: 159.494,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 162.463,
    y1: 134.229,
    x2: 162.463,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 165.137,
    y1: 135.723,
    x2: 165.137,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 168.105,
    y1: 139.305,
    x2: 168.105,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 171.073,
    y1: 138.408,
    x2: 171.073,
    y2: 144.978,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 174.039,
    y1: 134.229,
    x2: 174.039,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 176.711,
    y1: 131.541,
    x2: 176.711,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 179.68,
    y1: 128.256,
    x2: 179.68,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 182.647,
    y1: 131.242,
    x2: 182.647,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 185.616,
    y1: 134.229,
    x2: 185.616,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 188.288,
    y1: 135.125,
    x2: 188.288,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 191.259,
    y1: 143.187,
    x2: 191.259,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 194.223,
    y1: 139.902,
    x2: 194.223,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 197.19,
    y1: 136.32,
    x2: 197.19,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 199.865,
    y1: 133.334,
    x2: 199.865,
    y2: 144.981,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 202.833,
    y1: 128.256,
    x2: 202.833,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 205.802,
    y1: 129.152,
    x2: 205.802,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 208.768,
    y1: 130.346,
    x2: 208.768,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 211.439,
    y1: 137.812,
    x2: 211.439,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 214.407,
    y1: 136.617,
    x2: 214.407,
    y2: 144.979,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 217.376,
    y1: 141.695,
    x2: 217.376,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 220.344,
    y1: 140.799,
    x2: 220.344,
    y2: 144.98,
    stroke: "#DEDEDE",
    strokeWidth: 0.773298
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.321,
    cy: 111.532,
    rx: 1.48411,
    ry: 1.4932,
    fill: "#00822B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.9229,
    y: 110.039,
    width: 56.6931,
    height: 34.9408,
    fill: "#34CB65",
    fillOpacity: 0.15
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 111.151,
    y1: 113.025,
    x2: 111.151,
    y2: 144.98,
    stroke: "#00822B",
    strokeWidth: 0.257766
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.769 82.4188C57.5376 82.4188 67.078 72.8784 67.078 61.1098C67.078 49.3411 57.5376 39.8008 45.769 39.8008C34.0003 39.8008 24.46 49.3411 24.46 61.1098C24.46 72.8784 34.0003 82.4188 45.769 82.4188Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8984 66.7544C36.7294 66.4577 31.0184 67.6466 26.4951 71.3524C28.8084 74.4786 31.3898 77.4336 34.7019 79.8143C38.1746 81.5647 42.0094 82.4766 45.8984 82.4766C49.7874 82.4766 53.6222 81.5647 57.095 79.8143C60.6094 76.9887 63.0424 73.8853 65.3557 70.7591C60.8167 67.0533 54.0938 66.7544 45.8984 66.7544Z",
    fill: "#FE8A8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3857 66.9875C48.4314 66.0562 43.3469 66.0562 38.3926 66.9875C40.6002 69.0829 43.1582 70.2844 45.8892 70.2844C48.6201 70.2844 51.1781 69.0829 53.3857 66.9875Z",
    fill: "#EDB39A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4854 58.8398H50.2912V67.6457H41.4854V58.8398Z",
    fill: "#EDB39A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.013 49.4721C51.5077 48.073 50.2792 47.3588 48.8397 46.9074C47.564 46.5134 46.222 46.3805 44.8937 46.5166C42.603 46.7412 40.0517 47.5048 39.6161 50.0718C39.4678 50.9521 39.5015 51.8684 39.4768 52.7511C39.4382 54.1359 39.493 55.5217 39.6408 56.8991C39.7441 57.8738 39.9013 58.8664 40.3684 59.7288C40.9927 60.8854 42.0528 61.6378 43.2655 62.1745C43.5844 62.316 43.9146 62.4418 44.2492 62.5563C45.3134 62.9201 46.4684 62.9201 47.5326 62.5563C47.8672 62.4418 48.2063 62.316 48.514 62.1745C49.729 61.6378 50.7891 60.8854 51.4134 59.7288C51.8783 58.8664 52.0377 57.8738 52.141 56.8991C52.2671 55.7274 52.3249 54.5493 52.314 53.3709C52.314 52.2637 52.3903 51.0824 52.1612 50.0022C52.1254 49.822 52.0759 49.6448 52.013 49.4721Z",
    fill: "#EDB39A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1596 53.9249C39.4786 52.5145 38.8677 51.0188 39.1596 49.6039C39.4095 48.5758 40.0552 47.688 40.9563 47.1335C41.857 46.5872 42.8899 46.2976 43.9433 46.2958C44.1161 46.2787 44.2903 46.3074 44.4486 46.3789C44.5496 46.4436 44.6346 46.5304 44.6973 46.6327C44.7599 46.735 44.7985 46.8502 44.8101 46.9696C44.9584 47.8679 44.2824 48.6584 43.6558 49.3097C43.2673 49.7426 42.837 50.136 42.3712 50.4843C41.7334 50.9334 40.9496 51.2389 40.5453 51.9036C40.0827 52.6627 40.186 53.7834 39.4494 54.2842",
    fill: "#3A3A3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0519 47.5338C51.6521 47.0846 51.0413 46.9005 50.5606 46.5411C50.0127 46.1301 49.6623 45.5148 49.2132 44.9982C48.7583 44.4713 48.1954 44.0485 47.5625 43.7586C46.9297 43.4687 46.2418 43.3186 45.5457 43.3184C44.8495 43.33 44.1667 43.5124 43.5574 43.8496C42.9481 44.1867 42.4309 44.6683 42.0512 45.252C41.8649 45.5367 41.7353 45.8547 41.6694 46.1885C41.5302 46.9835 41.894 47.8055 42.4532 48.3849C43.0434 48.9401 43.7402 49.3695 44.5014 49.6471C46.131 50.2815 47.842 50.683 49.5837 50.8396C49.8194 50.8615 50.0461 50.9409 50.2439 51.0709C50.4416 51.2009 50.6044 51.3775 50.7179 51.5852C50.7716 51.6882 50.8182 51.7947 50.8571 51.9042C51.0121 52.3398 51.0705 52.8025 51.2119 53.2516C51.2381 53.3741 51.289 53.4898 51.3617 53.5918C51.4343 53.6938 51.527 53.7798 51.6342 53.8446C51.6858 53.87 51.742 53.8848 51.7994 53.8883C51.8569 53.8918 51.9145 53.8838 51.9688 53.8648C52.1732 53.7884 52.2113 53.593 52.2405 53.4156C52.4309 52.2074 52.5456 50.9886 52.5841 49.7661C52.6111 48.9868 52.5729 48.1199 52.0519 47.5338Z",
    fill: "#3A3A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3123 56.4813C41.1012 56.2046 41.4864 55.2553 41.1727 54.3611C40.859 53.4669 39.9653 52.9664 39.1764 53.2431C38.3875 53.5198 38.0023 54.469 38.316 55.3632C38.6297 56.2574 39.5234 56.758 40.3123 56.4813Z",
    fill: "#EDB39A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4745 55.3771C53.7881 54.4829 53.4029 53.5337 52.6141 53.257C51.8252 52.9803 50.9314 53.4809 50.6178 54.375C50.3041 55.2692 50.6893 56.2185 51.4782 56.4952C52.267 56.7719 53.1608 56.2713 53.4745 55.3771Z",
    fill: "#EDB39A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2856 54.4838L39.3035 54.4389L39.2249 54.54C39.1912 54.5625 39.2541 54.6096 39.2811 54.6568C39.3236 54.7321 39.3554 54.813 39.3754 54.8971C39.4136 55.0527 39.4136 55.2153 39.3754 55.371L39.6584 55.2946C39.6355 55.2707 39.6227 55.239 39.6227 55.2059C39.6227 55.1728 39.6355 55.141 39.6584 55.1172C39.7954 54.9487 39.5573 54.7084 39.4203 54.8769C39.3376 54.9672 39.2927 55.0857 39.2948 55.2081C39.2969 55.3305 39.3458 55.4475 39.4315 55.5349C39.4526 55.5555 39.4786 55.5702 39.5071 55.5777C39.5356 55.5853 39.5655 55.5853 39.594 55.5778C39.6225 55.5704 39.6485 55.5557 39.6697 55.5352C39.6908 55.5147 39.7062 55.489 39.7145 55.4608C39.7965 55.12 39.7426 54.7608 39.5641 54.4591C39.5365 54.3964 39.4955 54.3405 39.4439 54.2955C39.3922 54.2504 39.3313 54.2174 39.2654 54.1986C39.2005 54.1882 39.134 54.2025 39.0791 54.2387C39.0243 54.2748 38.9849 54.3303 38.9689 54.394C38.8948 54.6006 39.2204 54.6882 39.2945 54.4838H39.2856Z",
    fill: "#2F2C2B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8254 54.4036C52.8103 54.3435 52.7746 54.2906 52.7245 54.254C52.6745 54.2175 52.6132 54.1997 52.5514 54.2037C52.4811 54.2202 52.4155 54.2526 52.3598 54.2986C52.3041 54.3446 52.2598 54.4028 52.2302 54.4687C52.0525 54.7706 51.9993 55.1299 52.082 55.4703C52.0903 55.4986 52.1058 55.5242 52.1269 55.5447C52.148 55.5652 52.1741 55.5799 52.2026 55.5874C52.231 55.5948 52.261 55.5948 52.2894 55.5873C52.3179 55.5797 52.3439 55.565 52.365 55.5444C52.4507 55.457 52.4997 55.3401 52.5017 55.2176C52.5038 55.0952 52.4589 54.9767 52.3762 54.8864C52.237 54.718 51.9989 54.9583 52.1382 55.1267C52.1583 55.1527 52.1681 55.1852 52.1656 55.218C52.1631 55.2508 52.1485 55.2815 52.1247 55.3041L52.4077 55.3805C52.3511 55.1496 52.3807 54.9061 52.4908 54.6955C52.5177 54.6439 52.5918 54.5697 52.5604 54.5495L52.484 54.4485L52.4997 54.4934C52.5738 54.6978 52.9017 54.6102 52.8254 54.4036Z",
    fill: "#2F2C2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8722 54.8613C42.8173 55.0043 42.8033 55.1599 42.8317 55.3104C42.8402 55.3458 42.8566 55.3789 42.8798 55.4069C42.903 55.435 42.9323 55.4574 42.9655 55.4724C42.9986 55.4873 43.0348 55.4945 43.0712 55.4933C43.1076 55.4921 43.1432 55.4825 43.1753 55.4654C43.4134 55.3284 43.3595 54.9017 43.1753 54.7422C42.9912 54.5828 42.7733 54.8366 42.935 54.9803C42.9509 54.9947 42.9634 55.0124 42.9716 55.0322C42.9797 55.052 42.9834 55.0734 42.9822 55.0948C42.9799 55.121 42.9799 55.1473 42.9822 55.1734C42.9822 55.2049 42.926 55.1734 43.0069 55.1734H43.0967C43.1214 55.1734 43.1304 55.2273 43.1484 55.2206C43.1664 55.2139 43.1484 55.1353 43.1484 55.1285C43.156 55.0733 43.1696 55.0191 43.1888 54.9668C43.2562 54.758 42.9305 54.6704 42.8609 54.877L42.8722 54.8613Z",
    fill: "#2F2C2B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5059 54.8613C48.4511 55.0043 48.4371 55.1599 48.4655 55.3104C48.4739 55.3458 48.4904 55.3789 48.5136 55.4069C48.5367 55.435 48.566 55.4574 48.5992 55.4724C48.6324 55.4873 48.6686 55.4945 48.705 55.4933C48.7414 55.4921 48.777 55.4825 48.8091 55.4654C49.0472 55.3284 48.9955 54.9017 48.8091 54.7422C48.6227 54.5828 48.4071 54.8366 48.5688 54.9803C48.5845 54.9949 48.597 55.0127 48.6056 55.0324C48.6141 55.0521 48.6184 55.0734 48.6182 55.0948C48.6149 55.1209 48.6149 55.1473 48.6182 55.1734C48.6182 55.2049 48.5621 55.1734 48.6429 55.1734H48.7328C48.7575 55.1734 48.7665 55.2273 48.7844 55.2206C48.7867 55.19 48.7867 55.1592 48.7844 55.1285C48.792 55.0733 48.8056 55.0191 48.8248 54.9668C48.8922 54.758 48.5666 54.6704 48.4969 54.877L48.5059 54.8613Z",
    fill: "#2F2C2B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6447 56.3933V56.6673L45.8131 56.4989C45.3347 56.4629 44.9552 57.0469 45.3055 57.4309C45.5818 57.7341 46.3004 57.8172 46.5744 57.4668C46.7092 57.2984 46.4711 57.0558 46.3364 57.2265C46.2016 57.3972 45.9591 57.3635 45.7839 57.3186C45.6469 57.2827 45.4987 57.2175 45.5166 57.0581C45.5272 56.9895 45.5641 56.9277 45.6194 56.8858C45.6747 56.8439 45.7442 56.8251 45.8131 56.8335C45.8578 56.8329 45.9005 56.8151 45.9324 56.7837C45.9642 56.7523 45.9826 56.7098 45.9838 56.6651V56.3933C45.979 56.3517 45.959 56.3133 45.9278 56.2855C45.8965 56.2576 45.8561 56.2422 45.8142 56.2422C45.7723 56.2422 45.7319 56.2576 45.7006 56.2855C45.6694 56.3133 45.6494 56.3517 45.6447 56.3933Z",
    fill: "#2F2C2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8169 53.26C43.1852 53.26 43.5535 53.2398 43.9196 53.2106C44.1442 53.1949 44.1442 52.8558 43.9196 52.8737C43.5535 52.9029 43.1852 52.9187 42.8169 52.9231C42.7722 52.9231 42.7294 52.9409 42.6978 52.9725C42.6662 53.0041 42.6484 53.0469 42.6484 53.0916C42.6484 53.1363 42.6662 53.1791 42.6978 53.2107C42.7294 53.2423 42.7722 53.26 42.8169 53.26Z",
    fill: "#2F2C2B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9674 52.9231C48.5991 52.9231 48.233 52.9029 47.8647 52.8737C47.6401 52.8558 47.6401 53.1926 47.8647 53.2106C48.233 53.2398 48.5991 53.2578 48.9674 53.26C49.0121 53.26 49.0549 53.2423 49.0865 53.2107C49.1181 53.1791 49.1359 53.1363 49.1359 53.0916C49.1359 53.0469 49.1181 53.0041 49.0865 52.9725C49.0549 52.9409 49.0121 52.9231 48.9674 52.9231Z",
    fill: "#2F2C2B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8653 49.0261C43.9561 49.7103 45.1518 50.2111 46.4047 50.5083C47.0291 50.6633 47.6624 50.7823 48.2979 50.8856C49.0301 51.0046 50.0272 50.9642 50.6359 51.4268C50.8088 51.5571 50.9795 51.2629 50.8065 51.1349C49.9082 50.4611 48.3204 50.5734 47.2469 50.3511C45.7557 50.076 44.3281 49.5278 43.036 48.7341C42.8518 48.6173 42.6811 48.9093 42.8653 49.0261Z",
    fill: "#2F2C2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2809 56.044C50.3181 56.0397 50.3525 56.0218 50.3775 55.9938C50.4024 55.9658 50.4162 55.9296 50.4162 55.8921C50.4162 55.8546 50.4024 55.8184 50.3775 55.7904C50.3525 55.7624 50.3181 55.7445 50.2809 55.7402C50.2436 55.7445 50.2092 55.7624 50.1843 55.7904C50.1593 55.8184 50.1455 55.8546 50.1455 55.8921C50.1455 55.9296 50.1593 55.9658 50.1843 55.9938C50.2092 56.0218 50.2436 56.0397 50.2809 56.044Z",
    fill: "#2F2C2B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7946 51.8866C41.0955 51.3274 41.5671 51.1365 42.0994 50.8535C42.5436 50.6143 42.9507 50.3117 43.3077 49.9552C43.4649 49.8025 43.2246 49.5622 43.0696 49.7149C42.6041 50.1493 42.0737 50.5084 41.4975 50.7794C41.078 50.9774 40.7332 51.3049 40.5138 51.7137C40.4083 51.9046 40.7003 52.0752 40.8058 51.8844L40.7946 51.8866Z",
    fill: "#2F2C2B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6881 56.5928C40.7254 56.5885 40.7598 56.5706 40.7847 56.5426C40.8097 56.5146 40.8235 56.4784 40.8235 56.4409C40.8235 56.4034 40.8097 56.3672 40.7847 56.3392C40.7598 56.3112 40.7254 56.2934 40.6881 56.2891C40.6508 56.2934 40.6165 56.3112 40.5915 56.3392C40.5665 56.3672 40.5527 56.4034 40.5527 56.4409C40.5527 56.4784 40.5665 56.5146 40.5915 56.5426C40.6165 56.5706 40.6508 56.5885 40.6881 56.5928Z",
    fill: "#2F2C2B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5213 63.274C47.2753 63.2704 48.9619 62.5981 50.2375 61.3943C50.397 61.246 50.1567 61.0057 49.9972 61.154C48.7863 62.2974 47.1845 62.9353 45.519 62.9371C45.4744 62.9371 45.4315 62.9549 45.3999 62.9865C45.3683 63.0181 45.3506 63.0609 45.3506 63.1056C45.3506 63.1503 45.3683 63.1931 45.3999 63.2247C45.4315 63.2563 45.4744 63.274 45.519 63.274H45.5213Z",
    fill: "#2F2C2B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6023 63.2708C44.6439 63.266 44.6823 63.246 44.7102 63.2148C44.738 63.1835 44.7534 63.1431 44.7534 63.1012C44.7534 63.0593 44.738 63.0189 44.7102 62.9876C44.6823 62.9564 44.6439 62.9364 44.6023 62.9316C44.5607 62.9364 44.5223 62.9564 44.4944 62.9876C44.4666 63.0189 44.4512 63.0593 44.4512 63.1012C44.4512 63.1431 44.4666 63.1835 44.4944 63.2148C44.5223 63.246 44.5607 63.266 44.6023 63.2708Z",
    fill: "#2F2C2B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0086 58.9099C46.3787 58.9079 46.7418 58.8092 47.0621 58.6237C47.3823 58.4382 47.6486 58.1722 47.8344 57.8521C47.8571 57.8134 47.8634 57.7673 47.852 57.7239C47.8406 57.6805 47.8125 57.6434 47.7738 57.6208C47.7351 57.5981 47.6889 57.5918 47.6456 57.6032C47.6022 57.6146 47.5651 57.6427 47.5425 57.6814C47.3863 57.95 47.1626 58.173 46.8934 58.3283C46.6243 58.4835 46.3192 58.5656 46.0086 58.5663C45.967 58.5711 45.9286 58.591 45.9007 58.6222C45.8728 58.6535 45.8574 58.6939 45.8574 58.7358C45.8574 58.7777 45.8728 58.8181 45.9007 58.8494C45.9286 58.8807 45.967 58.9006 46.0086 58.9054V58.9099Z",
    fill: "#2F2C2B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2965 61.1098C67.2965 72.9991 57.6583 82.6373 45.769 82.6373C33.8797 82.6373 24.2416 72.9991 24.2416 61.1098C24.2416 49.2206 33.8797 39.5824 45.769 39.5824C57.6583 39.5824 67.2965 49.2206 67.2965 61.1098Z",
    stroke: "#C4E8D0",
    strokeWidth: 0.832764
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 25,
    r: 24,
    fill: "white",
    stroke: "#FFCD6E",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 272.353,
    y: 11.8157,
    width: 13.0185,
    height: 11.4646,
    rx: 5.73232,
    stroke: "#FFCD6E",
    strokeWidth: 3.03764
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 267.727,
    y: 17.7812,
    width: 22.2714,
    height: 18.1807,
    rx: 2.27259,
    fill: "#FFCD6E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.792,
    cy: 26.5413,
    r: 2.26009,
    fill: "#ECB143"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 278.039,
    y: 27.6719,
    width: 1.50673,
    height: 4.89687,
    rx: 0.753365,
    fill: "#ECB143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedArt);
export default __webpack_public_path__ + "static/media/access-denied-art.261a8ccb68d8aa6f002e93a8c1131df0.svg";
export { ForwardRef as ReactComponent };